import toast from "react-hot-toast";
import "./passwordForm.scss";
import { useUpdatePasswordMutation } from "../../../features/api/userApiSlice";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

// ✅ Validation Schema
const PasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required("Old password is required."),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters.")
    .matches(/[A-Z]/, "Must contain at least one uppercase letter.")
    .matches(/[a-z]/, "Must contain at least one lowercase letter.")
    .matches(/[0-9]/, "Must contain at least one number.")
    .matches(/[@$!%*?&]/, "Must contain at least one special character.")
    .required("New password is required."),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match.")
    .required("Confirm password is required."),
});

const PasswordForm = () => {
  const [updatePassword, { isLoading }] = useUpdatePasswordMutation();

  return (
    <Formik
      initialValues={{
        oldPassword: "",
        password: "",
        confirmPassword: "",
      }}
      validationSchema={PasswordSchema}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        try {
          await updatePassword({
            oldPassword: values.oldPassword,
            password: values.password,
          }).unwrap();
          toast.success("Password updated successfully!");
          resetForm();
        } catch (err) {
          toast.error(err?.data?.message || "Failed to update password");
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting, errors, touched }) => (
        <Form className="password-form">
          {/* Old Password */}
          <div className="form-controls">
            <label htmlFor="oldPassword">
              Old Password{" "}
              <span className="required-inputs" aria-label="required">
                *
              </span>
            </label>
            <Field
              type="password"
              id="oldPassword"
              name="oldPassword"
              className={
                errors.oldPassword && touched.oldPassword ? "input-error" : ""
              }
            />
            <ErrorMessage
              name="oldPassword"
              component="span"
              className="error"
            />
          </div>

          {/* New Password */}
          <div className="form-controls">
            <label htmlFor="password">
              New Password{" "}
              <span className="required-inputs" aria-label="required">
                *
              </span>
            </label>
            <Field
              type="password"
              id="password"
              name="password"
              className={
                errors.password && touched.password ? "input-error" : ""
              }
            />
            <ErrorMessage name="password" component="span" className="error" />
          </div>

          {/* Confirm Password */}
          <div className="form-controls">
            <label htmlFor="confirmPassword">
              Confirm Password{" "}
              <span className="required-inputs" aria-label="required">
                *
              </span>
            </label>
            <Field
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              className={
                errors.confirmPassword && touched.confirmPassword
                  ? "input-error"
                  : ""
              }
            />
            <ErrorMessage
              name="confirmPassword"
              component="span"
              className="error"
            />
          </div>

          <button
            type="submit"
            className="save-button"
            disabled={isSubmitting || isLoading}
          >
            {isSubmitting || isLoading ? "Saving..." : "Save Password"}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default PasswordForm;
